import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Adds top space so Angular Material outline form-field labels
 * (mat-label on appearance="outline") are not clipped by a parent
 * overflow or a tight heading above.
 *
 * Wrap each mat-form-field:
 * ```html
 * <app-outline-field>
 *   <mat-form-field appearance="outline">...</mat-form-field>
 * </app-outline-field>
 * ```
 */
@Component({
  selector: 'app-outline-field',
  templateUrl: './outline-field.component.html',
  styleUrls: ['./outline-field.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OutlineFieldComponent {}
